import { render, staticRenderFns } from "./bulmaMessage.vue?vue&type=template&id=770e9b08&scoped=true&"
import script from "./bulmaMessage.vue?vue&type=script&lang=js&"
export * from "./bulmaMessage.vue?vue&type=script&lang=js&"
import style0 from "./bulmaMessage.vue?vue&type=style&index=0&id=770e9b08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770e9b08",
  null
  
)

export default component.exports